import styled from 'styled-components'

const FulfilmentActionRow = styled.div`
  margin-left: 33px;
  margin-top: 15px;

  a,
  button + span {
    margin-left: 15px;
  }
`
const FulfilmentMessageAlternative = styled.div`
  background-color: ${props => props.theme.color.palette['brand-1-light']};
  padding: 15px;
  border-radius: 5px;
  margin-top: 10px;
  border-width: 1px 0 0;
  position: relative;
  margin-bottom: 5px;
`
const AlternativeMessageTitle = styled.p`
  font-size: 15px;
  margin-bottom: 10px;
`

export { FulfilmentActionRow, FulfilmentMessageAlternative, AlternativeMessageTitle }
